import { ILabelForm, ILabelResponse } from 'services/labels/types';

export const labelQueryToForm = (labelQuery: ILabelResponse): ILabelForm => {
  const {
    addressCity,
    addressCountry,
    addressFlatNumber,
    addressHouseNumber,
    addressStreet,
    addressZipCode,
    taxOfficeAddressCity,
    taxOfficeAddressCountry,
    taxOfficeAddressFlatNumber,
    taxOfficeAddressHouseNumber,
    taxOfficeAddressStreet,
    taxOfficeAddressZipCode,
    phoneNumberNumber,
    customerTypeId,
    accountDetailsBankAccountNumber,
    accountDetailsBankName,
    personalIdCountry,
    companyIdCompanyIdentification,
    companyIdCountry,
    legalSupervisorPersonalIdCountry,
    isOfLegalAgeValue,
    settlementMethodId,
    settlementMethodName,
    ...label
  } = {
    ...labelQuery,
    phoneNumber: labelQuery.phoneNumberNumber,
    customerType: labelQuery.customerTypeId,
    bankAccountNumber: labelQuery.accountDetailsBankAccountNumber ?? '',
    bankName: labelQuery.accountDetailsBankName ?? '',
    personalIdCountryAlfa2: labelQuery.personalIdCountry ?? '',
    companyId: labelQuery.companyIdCompanyIdentification ?? '',
    companyCountryAlfa2: labelQuery.companyIdCountry ?? '',
    legalSupervisorCountryAlfa2:
      labelQuery.legalSupervisorPersonalIdCountry ?? '',
    legalSupervisorFirstName: labelQuery.legalSupervisorFirstName ?? '',
    legalSupervisorLastName: labelQuery.legalSupervisorLastName ?? '',
    legalSupervisorPersonalId: labelQuery.legalSupervisorPersonalId ?? '',
    dateOfBirth: new Date(labelQuery?.dateOfBirth || new Date())
      .toISOString()
      .split('T')[0],
    address: {
      city: labelQuery.addressCity ?? '',
      flatNumber: labelQuery.addressFlatNumber ?? '',
      houseNumber: labelQuery.addressHouseNumber ?? '',
      countryAlfa2: labelQuery.addressCountry ?? '',
      street: labelQuery.addressStreet ?? '',
      zipCode: labelQuery.addressZipCode ?? '',
    },
    taxOffice: {
      name: labelQuery.taxOfficeName ?? '',
      city: labelQuery.taxOfficeAddressCity ?? '',
      flatNumber: labelQuery.taxOfficeAddressFlatNumber ?? '',
      countryAlfa2: labelQuery.taxOfficeAddressCountry ?? '',
      houseNumber: labelQuery.taxOfficeAddressHouseNumber ?? '',
      street: labelQuery.taxOfficeAddressStreet ?? '',
      zipCode: labelQuery.taxOfficeAddressZipCode ?? '',
    },
    notifyOnDocumentGeneration: labelQuery.notifyOnDocumentGeneration ?? false,
    swift: labelQuery.accountDetailsSwift ?? '',
  };

  return label;
};
